import React from 'react'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { MiniSheet } from '../../MiniSheet/index.js'
import {
  FORMAT_TEXT_COMMAND,
  FORMAT_ELEMENT_COMMAND,
  $getSelection,
  ParagraphNode,
} from 'lexical'
import {
  INSERT_ORDERED_LIST_COMMAND,
  INSERT_UNORDERED_LIST_COMMAND,
  REMOVE_LIST_COMMAND,
} from '@lexical/list'
import { TOGGLE_LINK_COMMAND } from '@lexical/link'
import { IconButton } from '../../IconButton/index.js'
import { $setBlocksType } from '@lexical/selection'
import { QuoteNode } from '@lexical/rich-text'

export const SmallMoreOptions = ({
  nodeType,
  isStrikethrough,
  isLink,
  align,
  disabled,
}) => {
  const [editor] = useLexicalComposerContext()

  return (
    <MiniSheet>
      <MiniSheet.Trigger>
        <div style={{ marginLeft: 'auto', marginRight: 8 }}>
          <IconButton
            tooltip="More"
            size="small"
            icon="more-horizontal"
            //   forceHover={open}
            disabled={disabled}
          />
        </div>
      </MiniSheet.Trigger>
      <MiniSheet.Items>
        {/* <MiniSheet.Item
                  icon="embed"
                  size="small"
                  onClick={() => {
                    setEmbedModalOpen(true)
                  }}
                  tooltip="Insert embed"
                /> */}

        <MiniSheet.Item
          tooltip={nodeType === 'quote' ? 'Remove Quote' : 'Quote'}
          size="small"
          icon="quote-on"
          keyHint="Cmd+Alt+Q"
          keyHintVisualOnly
          toggled={nodeType === 'quote'}
          onClick={() => {
            editor.update(() => {
              const selection = $getSelection()

              $setBlocksType(selection, () =>
                nodeType === 'quote' ? new ParagraphNode() : new QuoteNode(),
              )
            })
          }}
        />
        <MiniSheet.Item
          size="small"
          icon="list-bulleted"
          toggled={nodeType === 'bullet'}
          keyHint="Cmd+Alt+4"
          tooltip="Bulleted list"
          keyHintVisualOnly
          onClick={() => {
            editor.update(() => {
              editor.dispatchCommand(
                nodeType === 'bullet'
                  ? REMOVE_LIST_COMMAND
                  : INSERT_UNORDERED_LIST_COMMAND,
                undefined,
              )
            })
          }}
        />
        <MiniSheet.Item
          size="small"
          icon="list-numbered"
          keyHint="Cmd+Alt+5"
          keyHintVisualOnly
          tooltip="Number list"
          toggled={nodeType === 'number'}
          onClick={() => {
            editor.update(() => {
              editor.dispatchCommand(
                nodeType === 'number'
                  ? REMOVE_LIST_COMMAND
                  : INSERT_ORDERED_LIST_COMMAND,
                undefined,
              )
            })
          }}
        />
        <MiniSheet.Item
          tooltip="Strikethrough"
          size="small"
          keyHint="Cmd+Shift+S"
          keyHintVisualOnly
          toggled={isStrikethrough}
          icon="strikethrough-text"
          onClick={() => {
            editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'strikethrough')
          }}
        />
        <MiniSheet.Item
          tooltip={'Insert link'}
          keyHint="Cmd+K"
          keyHintVisualOnly
          size="small"
          icon="link-on"
          toggled={isLink}
          onClick={() => {
            editor.update(() => {
              editor.dispatchCommand(TOGGLE_LINK_COMMAND, isLink ? null : '')
            })
          }}
        />
        <MiniSheet.Item
          size="small"
          icon="aligned-text-left"
          tooltip="Align left"
          keyHint="Cmd+Shift+L"
          keyHintVisualOnly
          onClick={() => {
            editor.dispatchCommand(FORMAT_ELEMENT_COMMAND, 'left')
          }}
          toggled={align === 'left'}
        />
        <MiniSheet.Item
          size="small"
          icon="aligned-text-center"
          tooltip="Align center"
          keyHint="Cmd+Shift+E"
          keyHintVisualOnly
          onClick={() => {
            editor.dispatchCommand(FORMAT_ELEMENT_COMMAND, 'center')
          }}
          toggled={align === 'center'}
        />
        <MiniSheet.Item
          size="small"
          icon="aligned-text-right"
          tooltip="Align right"
          keyHint="Cmd+Shift+R"
          keyHintVisualOnly
          onClick={() => {
            editor.dispatchCommand(FORMAT_ELEMENT_COMMAND, 'right')
          }}
          toggled={align === 'right'}
        />
      </MiniSheet.Items>
    </MiniSheet>
  )
}
